import React, {useState} from 'react';

import GridContainer from "@/components/common/GridContainer";
import styled from "styled-components";
import {getCssSizeValue, getMapKey, groupArrayBySize, isStringEmpty} from "@/utils/utils";
import {BREAKPOINTS} from "@/styles/themeSettings";
import HeaderDescriptionBlock from "@/components/HeaderDescriptionBlock";
import ImageContent from "@/components/TilesModule/variants/TilesFilesModule/ImageContent";
import HeaderContent from "@/components/TilesModule/variants/TilesFilesModule/HeaderContent";
import DescriptionContent from "@/components/TilesModule/variants/TilesFilesModule/DescriptionContent";
import {useIsDesktop, useIsMobile} from "@/hooks/useDevice";

const RowWrapper = styled.div`
    margin-bottom: ${getCssSizeValue(40, BREAKPOINTS.MOBILE)};

    @media (min-width: ${({theme}) => theme.breakpoints.desktop || 1024}px) and (orientation: landscape) {
        margin-bottom: ${getCssSizeValue(32, BREAKPOINTS.DESKTOP)};
    }
`

export default function TilesFilesModule({data, paddings, headerDescription}) {
	const isDesktop = useIsDesktop()
	const isMobile = useIsMobile()
	const id = data?.id || ''
	const tiles = data?.tiles || []
	const [hoveredId, setHoveredId] = useState(null)

	const arrays = groupArrayBySize(tiles, isDesktop ? 4 : isMobile ? 1 : 2)

	const handleDownload = () => {
		const item = tiles.find(tile => tile.id === hoveredId)
		if (!item) return

		const downloadAssetUrl = item?.downloadAsset?.url || ''
		if (isStringEmpty(downloadAssetUrl)) return

		const link = document.createElement('a');
		link.href = downloadAssetUrl;
		link.target = "_blank";
		link.download = true;
		link.rel = "noopener noreferrer";
		link.click();
	};

	return (
		<div className={paddings} id={id}>
			<HeaderDescriptionBlock headerDescription={headerDescription}/>
			<div>
				{/* Split each card for three parts to keep equal height of each row*/}
				{arrays.map((item, index) => (
					<RowWrapper key={index}>
						<GridContainer>
							{arrays[index].map((tile, index) => {
								return <ImageContent
									key={getMapKey(tile, index)}
									data={tile}
									hoveredId={hoveredId}
									setHoveredId={setHoveredId}
									handleDownload={handleDownload}
								/>
							})}
						</GridContainer>
						<GridContainer>
							{arrays[index].map((tile, index) => {
								return <HeaderContent
									key={getMapKey(tile, index)}
									data={tile}
									hoveredId={hoveredId}
									setHoveredId={setHoveredId}
									handleDownload={handleDownload}
								/>
							})}
						</GridContainer>
						<GridContainer>
							{arrays[index].map((tile, index) => {
								return <DescriptionContent
									key={getMapKey(tile, index)}
									data={tile}
									hoveredId={hoveredId}
									setHoveredId={setHoveredId}
									handleDownload={handleDownload}
								/>
							})}
						</GridContainer>
					</RowWrapper>
				))}
			</div>
		</div>
	)
}